import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  listItem: {
    paddingVertical: 0,
    marginTop: 10,
  },
  listItemFirst: {
    marginTop: 0,
  },
});
